import { Stack } from "@mui/material";
import { H5Component } from "./H5Component";
import { TextBlock } from "./TextBlock";
import { DataPersonIcon } from "../../../images";

export const PersonList = ({
  data,
  showIcon = true,
}: {
  data: { title: string; text: string[] }[];
  showIcon?: boolean;
}) => {
  if (!data || !Array.isArray(data)) return null;
  return (
    <Stack gap="20px">
      {data.map(({ title, text }) => (
        <Stack gap="16px">
          <Stack gap="4px">
            <Stack flexDirection="row" gap="8px" alignItems="center">
              {showIcon && <DataPersonIcon width="16px" height="16px" />}
              <H5Component text={title} />
            </Stack>
            <TextBlock text={text} />
          </Stack>
        </Stack>
      ))}
    </Stack>
  );
};
